import React, { useState } from 'react';
const ClanManagement = () => {
  const [clans, setClans] = useState([{
    id: 1,
    name: 'React Ninjas',
    members: 24,
    focus: 'Frontend',
    joinable: true
  }, {
    id: 2,
    name: 'Algorithm Masters',
    members: 16,
    focus: 'DSA',
    joinable: true
  }, {
    id: 3,
    name: 'DevOps Warriors',
    members: 12,
    focus: 'Infrastructure',
    joinable: false
  }]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newClan, setNewClan] = useState({
    name: '',
    focus: '',
    joinable: true
  });
  const handleCreate = e => {
    e.preventDefault();
    setClans([...clans, {
      id: Date.now(),
      name: newClan.name,
      members: 1,
      focus: newClan.focus,
      joinable: newClan.joinable
    }]);
    setNewClan({
      name: '',
      focus: '',
      joinable: true
    });
    setShowCreateForm(false);
  };
  const joinClan = id => {
    setClans(clans.map(clan => clan.id === id ? {
      ...clan,
      members: clan.members + 1
    } : clan));
  };
  return <div data-id="element-6">
      <div className="flex justify-between items-center mb-4" data-id="element-7">
        <h2 className="text-xl font-bold" data-id="element-8">Developer Clans</h2>
        <button className="bg-blue-600 hover:bg-blue-500 text-white px-3 py-1 rounded-md text-sm" onClick={() => setShowCreateForm(!showCreateForm)} data-id="element-9">
          {showCreateForm ? 'Cancel' : 'Create Clan'}
        </button>
      </div>
      {showCreateForm ? <form onSubmit={handleCreate} className="bg-gray-700 p-3 rounded-md mb-4" data-id="element-10">
          <div className="mb-3" data-id="element-11">
            <label className="block text-sm mb-1" data-id="element-12">Clan Name</label>
            <input type="text" className="w-full bg-gray-800 border border-gray-600 rounded px-2 py-1 text-white" value={newClan.name} onChange={e => setNewClan({
          ...newClan,
          name: e.target.value
        })} required data-id="element-13" />
          </div>
          <div className="mb-3" data-id="element-14">
            <label className="block text-sm mb-1" data-id="element-15">Focus Area</label>
            <select className="w-full bg-gray-800 border border-gray-600 rounded px-2 py-1 text-white" value={newClan.focus} onChange={e => setNewClan({
          ...newClan,
          focus: e.target.value
        })} required data-id="element-16">
              <option value="" data-id="element-17">Select Focus</option>
              <option value="Frontend" data-id="element-18">Frontend</option>
              <option value="Backend" data-id="element-19">Backend</option>
              <option value="Mobile" data-id="element-20">Mobile</option>
              <option value="DevOps" data-id="element-21">DevOps</option>
              <option value="DSA" data-id="element-22">Data Structures & Algorithms</option>
              <option value="AI/ML" data-id="element-23">AI & Machine Learning</option>
            </select>
          </div>
          <div className="mb-3 flex items-center" data-id="element-24">
            <input type="checkbox" id="joinable" checked={newClan.joinable} onChange={e => setNewClan({
          ...newClan,
          joinable: e.target.checked
        })} className="mr-2" data-id="element-25" />
            <label htmlFor="joinable" className="text-sm" data-id="element-26">
              Open for new members
            </label>
          </div>
          <button type="submit" className="bg-green-600 hover:bg-green-500 text-white px-3 py-1 rounded-md w-full" data-id="element-27">
            Create Clan
          </button>
        </form> : <div className="space-y-3 max-h-[400px] overflow-y-auto" data-id="element-28">
          {clans.map(clan => <div key={clan.id} className="bg-gray-700 p-3 rounded-md" data-id="element-29">
              <h3 className="font-bold" data-id="element-30">{clan.name}</h3>
              <div className="flex justify-between text-sm text-gray-300" data-id="element-31">
                <span data-id="element-32">{clan.members} members</span>
                <span data-id="element-33">Focus: {clan.focus}</span>
              </div>
              {clan.joinable ? <button className="mt-2 bg-blue-600 hover:bg-blue-500 text-white text-sm px-3 py-1 rounded-md w-full" onClick={() => joinClan(clan.id)} data-id="element-34">
                  Join Clan
                </button> : <button className="mt-2 bg-gray-600 text-gray-400 text-sm px-3 py-1 rounded-md w-full cursor-not-allowed" disabled data-id="element-35">
                  Closed
                </button>}
            </div>)}
        </div>}
    </div>;
};
export default ClanManagement;